import {Pipe, PipeTransform} from '@angular/core';
import {BatchStatusUtil} from '../util/batchStatusUtil';
import {BatchStatus} from 'web-angular-client';

@Pipe({
    name: 'getBatchStatusDescription',
    standalone: false
})
export class BatchStatusPipe implements PipeTransform
{
    constructor(
        protected batchStatusUtil: BatchStatusUtil)
    {
    }

    transform(batchStatus: BatchStatus): string
    {
        return this.batchStatusUtil.getShortDescription(batchStatus);
    }
}